import React from 'react';

function Checkbox({ id, title, checked, onChange, className }) {
  return (
    <div className="form-check form-switch mb-3">
      <input
        className={`form-check-input ${className}`}
        type="checkbox"
        role="switch"
        id={id}
        checked={checked}
        onChange={onChange}
      />
      <label className="form-check-label" htmlFor={id}>
        {title}
      </label>
    </div>
  );
}

export default Checkbox;
